// extracted by mini-css-extract-plugin
export default {"label":"WXCSwC1ETQ7VCUu5GwZQ","content":"t9IGZ_SH1ka_rFkIm32J","last":"v4wMfMkCc6GgdT7jPSXQ"};